import { ReactNode } from 'react';
import { ImageAspectRatio } from 'types/Common';
import { CoverAsset } from 'types/Asset';

export abstract class BasePresenterSelector {
    protected assets: CoverAsset[];

    protected variant?: string;

    protected aspectRatio?: ImageAspectRatio;

    protected hideChannelLogo?: boolean;

    protected showEpisodeDescription?: boolean;

    protected hideGenre?: boolean;

    setAssets = (assets: CoverAsset[]): BasePresenterSelector => {
        this.assets = assets;
        return this;
    };

    setVariant(variant: string) {
        this.variant = variant;
        return this;
    }

    setAspectRatio(aspectRatio: ImageAspectRatio) {
        this.aspectRatio = aspectRatio;
        return this;
    }

    setHideChannelLogo(hideChannelLogo: boolean) {
        this.hideChannelLogo = hideChannelLogo;
        return this;
    }

    setShowEpisodeDescription(showEpisodeDescription: boolean) {
        this.showEpisodeDescription = showEpisodeDescription;
        return this;
    }

    setHideGenre(hideGenre: boolean) {
        this.hideGenre = hideGenre;
        return this;
    }

    abstract get: () => ReactNode[];
}
